// import React from "react";
// import ReactDOM from "react-dom/client";
// import { Provider } from "react-redux";

// import { HashRouter } from "react-router-dom";

// import App from "./App";
// import { store } from "./store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <HashRouter hashType="hashbang">
//       <App />
//     </HashRouter>
//   </Provider>
// );
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { store } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter hashType="hashbang">
      <App />
    </BrowserRouter>
  </Provider>
);
